import { connect } from 'react-redux';

import { IDictionaryKnoOrganizationSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryKnoOrganizationSelectOption';
import { IDictionarySupervisionTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySupervisionTypeSelectOption';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IKnmErknmFormSubject } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormSubject';
import { IBooleanSelectOption } from 'KnmPackage/MainModule/interfaces/IBooleanSelectOption';
import { IKnmPmFormRequirementsNpa } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormRequirementsNpa';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { appealStatusSelectOptions } from 'KnmErknmPackage/MainModule/constants/appealStatusSelectOptions';
import { Section } from 'UIPackage/FormModule/components/Section';
import { getAdminFetchSettings } from 'PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { getIsPmPaperlessActEnabled } from 'KnmPmPackage/MainModule/common/getIsPmPaperlessActEnabled';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { IKnmPmForm } from 'KnmPmPackage/MainModule/interfaces/IKnmPmForm';
import { getKnmPmResultDecisionsEditEnabled } from 'KnmPmPackage/MainModule/selectors/knmPmSelectors';
import { getKnmDataResigningRequired, getKnmStatusCode } from 'KnmPackage/MainModule/selectors/knmSelectors';
import { ProfKindCodesEnum } from 'APIPackage/DictionariesModule/enums/ProfKindCodesEnum';
import { KnmErknmStatusCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmErknmStatusCodesEnum';
import { IKnmStatus } from 'APIPackage/CatalogsModule/interfaces/IKnmStatus';

import { PmResultOfInspectionItem } from './PmResultOfInspectionItem';
import { PmAct } from './PmAct/PmAct';
import { PmResultOfInspectionPmResultDecisions } from './PmResultOfInspectionPmResultDecisions';
import { PmResultOfInspectionItemResultOfInspection } from './PmResultOfInspectionItemResultOfInspection';
import { IKnmErknmFormObject } from '../../../KnmErknmPackage/MainModule/interfaces/IKnmErknmFormObject';
import { IKnmFormRiskIndicators } from '../../../KnmPackage/MainModule/interfaces/IKnmFormRiskIndicators';

interface IPmResultOfInspectionProps {
  className?: string;
  watchOnly: boolean;
  withoutIssue?: boolean;
  isUnableToRefuse?: boolean;
  pmSubject?: IKnmErknmFormSubject;
  objectsPm?: IKnmErknmFormObject[];
  riskIndicators?: IKnmFormRiskIndicators[];
  hasResultDecisions: boolean;
  knoOrganization: IDictionaryKnoOrganizationSelectOption | undefined;
  supervisionType: IDictionarySupervisionTypeSelectOption | undefined;
  isViolatedMandatoryRequirements: IBooleanSelectOption | undefined;
  requirementsNpa: IKnmPmFormRequirementsNpa[] | undefined;
  values: IKnmPmForm;
}

interface IPmResultOfInspectionStoreProps {
  settings: IAdminSetting[];
  isResultDecisionsEditEnabled: boolean;
  resigningRequired: boolean;
  statusCode: IKnmStatus['code'] | undefined;
}

export const PmResultOfInspectionWithoutStore = ({
  className = '',
  watchOnly,
  knoOrganization,
  supervisionType,
  requirementsNpa,
  isViolatedMandatoryRequirements,
  pmSubject,
  objectsPm,
  riskIndicators,
  hasResultDecisions,
  withoutIssue,
  isUnableToRefuse,
  settings,
  values,
  isResultDecisionsEditEnabled,
  resigningRequired,
  statusCode,
}: IPmResultOfInspectionProps & IPmResultOfInspectionStoreProps) => {
  const isPaperlessActEnabled = getIsPmPaperlessActEnabled(values.created, settings);
  const isResultOfInspectionEditDisabled =
    !isUnableToRefuse &&
    values?.pmType?.code === ProfKindCodesEnum.PP &&
    statusCode === KnmErknmStatusCodesEnum.TYPE_COMPLETED;

  return (
    <>
      {isPaperlessActEnabled ? (
        <>
          {isUnableToRefuse ? (
            <PmAct
              watchOnly={watchOnly}
              values={values}
              requirementsNpa={requirementsNpa}
              knoOrganization={knoOrganization}
              objectsPm={objectsPm}
              riskIndicators={riskIndicators}
              supervisionType={supervisionType}
            />
          ) : (
            <PmResultOfInspectionItemResultOfInspection watchOnly={watchOnly || !!isResultOfInspectionEditDisabled} />
          )}
          <FieldBlock margin="top">
            <PmResultOfInspectionPmResultDecisions
              watchOnly={watchOnly || !isResultDecisionsEditEnabled || !!isResultOfInspectionEditDisabled}
              clearWatchOnly={watchOnly}
              withoutIssue={withoutIssue}
              pmSubject={pmSubject}
              isPaperless
              values={values}
              resigningRequired={resigningRequired}
            />
          </FieldBlock>
        </>
      ) : (
        <PmResultOfInspectionItem
          className={className}
          watchOnly={watchOnly}
          withoutIssue={withoutIssue}
          isUnableToRefuse={isUnableToRefuse}
          pmSubject={pmSubject}
          values={values}
          hasResultDecisions={hasResultDecisions}
          knoOrganization={knoOrganization}
          supervisionType={supervisionType}
          objectsPm={objectsPm}
          riskIndicators={riskIndicators}
          requirementsNpa={requirementsNpa}
          isViolatedMandatoryRequirements={isViolatedMandatoryRequirements}
        />
      )}
      <Section title={null}>
        <FieldBlock label="Сведения о жалобах на действия и решения КНО и их должностных лиц">
          <SelectInputField
            name="appealStatus"
            size="medium"
            disabled
            options={appealStatusSelectOptions}
            isClearable={false}
          />
        </FieldBlock>
      </Section>
    </>
  );
};

const mapStateToProps = (state: IRootState): IPmResultOfInspectionStoreProps => ({
  settings: getAdminFetchSettings(state),
  isResultDecisionsEditEnabled: getKnmPmResultDecisionsEditEnabled(state),
  resigningRequired: getKnmDataResigningRequired(state),
  statusCode: getKnmStatusCode(state),
});

export const PmResultOfInspection = connect(mapStateToProps)(PmResultOfInspectionWithoutStore);
